const toast = (name) => ({
  customErrorMessage: `Unable to retrieve "${name}" data. Please try again later.`,
  showErrorToast: true
})

export const withFallbackReportData = async (request) => {
  try {
    return await request({ toast })
  } catch (e) {
    return {
      labels: [],
      data: []
    }
  }
}

export default withFallbackReportData
